import { render } from "./NotificationBar.vue?vue&type=template&id=75ba45b9&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=75ba45b9&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ba45b9"]])

export default __exports__